import React, { useState } from 'react';
import { Question } from '../../../../../types/seatApproval';
import styles from './index.module.scss';
import GrayLine from '../../../../../common/components/GrayLine';
import CaretCircleDown from '../../../../../assets/images/CaretCircleDown.svg';

interface QuestionsSectionProps {
  questions: Question[];
  onShowAll?: () => void;
}

const QuestionsSection: React.FC<QuestionsSectionProps> = ({ questions, onShowAll }) => {
  const [isQuestionVisible, setIsQuestionVisible] = useState(true)

  return (
    <div className={styles.questionsSection}>
      <div className={styles.questionsHeader}>
        <h3>Questions</h3>
        <GrayLine />
        {/* <button className={styles.showAllBtn} onClick={onShowAll}>Show all</button> */}
        <img src={CaretCircleDown} alt="Show all" onClick={() => { setIsQuestionVisible(!isQuestionVisible) }} />
      </div>
      {isQuestionVisible && (
        <div className={styles.questionsList}>
          {questions.map((item, index) => (
            <div key={item.id} className={styles.questionItem}>
              <div className={styles.questionNumber}>{index + 1}.</div>
              <div className={styles.questionContent}>
                <div className={styles.question}>{item.questionLabel}</div>
                <div className={styles.answer}>{item.answer}</div>
              </div>
            </div>
          ))}
        </div>
      )}

    </div>
  );
};

export default QuestionsSection;
